// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

export const postalCodeValidation = {
    ar: { regex: '^\\w{1,8}$' },
    arg: { regex: '^\\w{1,8}$' },

    at: { regex: '^\\d{1,4}$' },
    aut: { regex: '^\\d{1,4}$' },

    au: { regex: '^\\d{1,4}$' },
    aus: { regex: '^\\d{1,4}$' },

    be: { regex: '^\\d{1,4}$' },
    bel: { regex: '^\\d{1,4}$' },

    bg: { regex: '^[\\w\\s]{1,4}$' },
    bgr: { regex: '^[\\w\\s]{1,4}$' },

    br: { regex: '^\\d{5}-\\d{3}$' },
    bra: { regex: '^\\d{5}-\\d{3}$' },

    ca: { regex: '^[\\w\\s-]{1,7}$' },
    can: { regex: '^[\\w\\s-]{1,7}$' },

    ch: { regex: '^\\d{4}$' },
    che: { regex: '^\\d{4}$' },

    cn: { regex: '^\\d{6}$' },
    chn: { regex: '^\\d{6}$' },

    cy: { regex: '^\\d{4}$' },
    cyp: { regex: '^\\d{4}$' },
   
    cz: { regex: '^\\d{3}(?:[-\\s]\\d{2})?$' },
    cze: { regex: '^\\d{3}(?:[\\s]\\d{2})?$' },
    
    de: { regex: '^\\w{1,6}$' },
    deu: { regex: '^\\w{1,6}$' },

    dk: { regex: '^\\d{4}$' },
    dnk: { regex: '^\\d{4}$' },

    es: { regex: '^\\d{5}$' },
    esp: { regex: '^\\d{5}$' },

    fi: { regex: '^\\d{5}$' },
    fin: { regex: '^\\d{5}$' },

    fr: { regex: '^\\d{5}$' },
    fra: { regex: '^\\d{5}$' },

    gb: { regex: '^[\\w\\s]{1,9}$' },
    gbr: { regex: '^[\\w\\s]{1,9}$' },

    gr: { regex: '^[\\d]{5,6}$' },
    grc: { regex: '^[\\d]{5,6}$' },

    hn: { regex: '^\\w{1,5}$' },
    hnd: { regex: '^\\w{1,5}$' },

    hr: { regex: '^\\d{5}$' },
    hrv: { regex: '^\\d{5}$' },

    hu: { regex: '^\\d{4}$' },
    hun: { regex: '^\\d{4}$' },

    id: { regex: '^\\d{5}$' },
    idn: { regex: '^\\d{5}$' },

    il: { regex: '^[\\w\\s]{1,7}$' },
    isr: { regex: '^[\\w\\s]{1,7}$' },

    in: { regex: '^\\d{6}$' },
    ind: { regex: '^\\d{6}$' },

    it: { regex: '^\\d{5}$' },
    ita: { regex: '^\\d{5}$' },

    jm: { regex: '^\\w{1,7}$' },
    jam: { regex: '^\\w{1,7}$' },

    kr: { regex: '^[\\w\\s]{1,7}$' },
    kor: { regex: '^[\\w\\s]{1,7}$' },

    lt: { regex: '^([Ll][Tt][- ]){0,1}\\d{5}$' },
    ltu: { regex: '^([Ll][Tt][- ]){0,1}\\d{5}$' },

    lu: { regex: '^[\\d\\s]{1,4}$' },
    lux: { regex: '^[\\d\\s]{1,4}$' },

    mc: { regex: '^\\d{5}$' },
    mco: { regex: '^\\d{5}$' },

    mx: { regex: '^\\d{5}$' },
    mex: { regex: '^\\d{5}$' },

    my: { regex: '^[\\w\\s]{1,7}$' },
    mys: { regex: '^[\\w\\s]{1,7}$' },

    nl: { regex: '^[\\w\\s]{1,7}$' },
    nld: { regex: '^[\\w\\s]{1,7}$' },

    no: { regex: '^\\d{4}$' },
    nor: { regex: '^\\d{4}$' },

    pl: { regex: '^[\\w-]{6}$' },
    pol: { regex: '^[\\w-]{6}$' },

    pt: { regex: '^[\\w\\s-]{1,8}$' },
    prt: { regex: '^[\\w\\s-]{1,8}$' },

    ro: { regex: '^[\\d\\s]{1,6}$' },
    rou: { regex: '^[\\d\\s]{1,6}$' },

    ru: { regex: '^\\d{6}$' },
    rus: { regex: '^\\d{6}$' },

    sa: { regex: '^\\d{5}$' },
    sau: { regex: '^\\d{5}$' },

    se: { regex: '^[\\w\\s]{6}$' },
    swe: { regex: '^[\\w\\s]{6}$' },

    sg: { regex: '^[\\w\\s]{1,8}$' },
    sgp: { regex: '^[\\w\\s]{1,8}$' },

    si: { regex: '^\\d{4}$' },
    svn: { regex: '^\\d{4}$' },

    sk: { regex: '^[\\w\\s]{1,6}$' },
    svk: { regex: '^[\\w\\s]{1,6}$' },

    th: { regex: '^\\d{5}$' },
    tha: { regex: '^\\d{5}$' },

    tr: { regex: '^\\d{5}$' },
    tur: { regex: '^\\d{5}$' },

    tt: { regex: '^\\w{1,6}$' },
    tto: { regex: '^\\w{1,6}$' },

    tw: { regex: '^\\w{1,6}$' },
    twn: { regex: '^\\w{1,6}$' },

    us: { regex: '^[0-9]{5}(?:-[0-9]{4})?$' },
    usa: { regex: '^[0-9]{5}(?:-[0-9]{4})?$' },

    uy: { regex: '^\\w{5}$' },
    ury: { regex: '^\\w{5}$' },

    za: { regex: '^\\d{4}$' },
    zaf: { regex: '^\\d{4}$' },

    ph: { regex: '^\\d{4}$' },
    phl: { regex: '^\\d{4}$' },

    vn: { regex: '^\\d{1,6}$' },
    vnm: { regex: '^\\d{1,6}$' },

    nz: { regex: '^\\d{4}$' },
    nzl: { regex: '^\\d{4}$' },

    eg: { regex: '^\\d{4}$|^\\d{5}$' },
    egy: { regex: '^\\d{4}$|^\\d{5}$' },
};

export function getPostalCodePattern(countryCode: string): any {
    return postalCodeValidation[countryCode];
}
